import { render, staticRenderFns } from "./RecipeInvoice.vue?vue&type=template&id=48573c0e&scoped=true"
import script from "./RecipeInvoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecipeInvoice.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RecipeInvoice.vue?vue&type=style&index=0&id=48573c0e&prod&scoped=true&lang=css"
import style1 from "./RecipeInvoice.vue?vue&type=style&index=1&id=48573c0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48573c0e",
  null
  
)

export default component.exports